import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
    FormulariosService,
    FormularioAtributo
} from '../../infrastructure/services/formularios.service';
import { LoaderService } from '../../infrastructure/services/loader.service';
import { Location } from '@angular/common';
import { Translator } from 'angular-translator';
import { AlertService } from '../../infrastructure/services/alert.service';
import { KeyValueBuilderComponent } from '../../helpers/components/kevValueBuilder/keyValueBuilder.component';
import { ListadoSiteTemplatesComponent } from '../siteTemplates/listado.siteTemplates.component';
import { JsonEditorOptions } from 'angular4-jsoneditor/jsoneditor/jsoneditor.component';



@Component({
    templateUrl: './detalle.atributos.component.html',
})
export class DetalleAtributosComponent implements OnInit {
  @ViewChild('keyValue') keyValue: KeyValueBuilderComponent;
  codFormulario;

  atributo: FormularioAtributo;

  esNuevo = false;
  errores = {
      codAtributo: null,
      descripcion: null,
  };

  isList = false;
  isListEditable = false;

  editorOptions: JsonEditorOptions;
  jdefaults: any;


  // Opciones Tipo Dato
  opciones = [
    'DateTime',
    'String',
    'Decimal',
    'Int32',
    'Int64',
    'Boolean',
    'Email',
    'TABLA',
    'TABLA_SIMPLE',
    'LIST',
    'Custom',
    'DateTimeISO'
  ];

  constructor(private aRoute: ActivatedRoute,
      public loader: LoaderService,
      private router: Router,
      private location: Location,
      private translator: Translator,
      private alertService: AlertService,
      private formularioService: FormulariosService) {
        this.editorOptions = new JsonEditorOptions();
        this.editorOptions.modes = ['code', 'text', 'tree', 'view'];
       }
      

  ngOnInit() {
      this.aRoute.params.subscribe(params => {
          const codAtributo = params['codAtributo'];
          this.codFormulario = params['codFormulario'];

          this.esNuevo = false;

          if (codAtributo === 'nuevo') {
              this.inicializarNuevo();
              this.esNuevo = true;
              this.isListEditable = false;
              return;
          }

          this.formularioService.getAtributos(this.codFormulario)
            .then(atributos => {
                this.atributo = atributos.find(atr => atr.codAtributo === codAtributo);
                if(this.atributo.tipoDato === 'LIST'){
                    this.isList = true;
                    this.isListEditable = true;
                    this.jdefaults = JSON.parse(this.atributo.valorDefault);
                }
            });
      });
  }

  guardar() {
    this.build();
    if (this.datosValidos()) {
      this.formularioService.crearAtributo(this.atributo)
        .then(newAtributo =>
        {
            this.router.navigate(['../', newAtributo.codAtributo.toUpperCase()], { relativeTo: this.aRoute });
        });
    }
  }

  editar() {
    this.build();
    if (this.datosValidos()) {
        this.formularioService.editarAtributo(this.atributo)
          .then(success => {
            this.alertService.showSuccessMessage('EDITAR_ATRIBUTO_OK');
          });
      }
  }

  build() {
    if (this.atributo.tipoDato === 'TABLA_SIMPLE') {
      this.atributo.extraInfo = this.keyValue.items;
    }
  }

  private inicializarNuevo() {
      this.atributo = {
          idFormulario: this.codFormulario,
          codAtributo: '',
          descripcion: '',
          extraInfo: '',
          commandCategory : '',
          commandSubCategory:'',
          valorDefault: null,
          tipoDato: 'DateTime',
          opcional: false,
          hidden:false,
          parsedMetadata: {
              columnaEnlaceDB: null,
              esColumna: false,
              esFiltro: false,
              esOrdenable: false,
              esVisible: false,
              extraInfo: null,
              position: null,
              tablaEnlaceDB: null,
              tipoFiltro: null,
          },
          formList: null,
      };
  }

  // TODO: Refactor a estas validaciones!!
  private datosValidos() {
      let esValido = true;
      //Attributecode contains only number, letters and underscore
      let regexInvalidAttributeCode = new RegExp('[^a-zA-Z0-9_-]+');
     

      // reseteo los errores antes de checkear nuevamente
      this.resetearErrores();

      if (this.atributo.codAtributo === null || this.atributo.codAtributo.length <= 0) {
          this.errores['codAtributo'] = <string>this.translator.instant('VALOR_REQUERIDO');
          esValido = false;
      }
      
      
      if (this.atributo.codAtributo !== null && this.atributo.codAtributo.length > 40) {
          this.errores['codAtributo'] =  <string>this.translator.instant('MAX_LONGITUD', { max: 40 });
          esValido = false;
      }

      if (this.atributo.codAtributo !== null && regexInvalidAttributeCode.test(this.atributo.codAtributo)) {
        this.errores['codAtributo'] = <string>this.translator.instant('INVALID_ATTR_SPECIAL_CHARACTER');
        esValido = false;
      }

      if (this.atributo.descripcion === null || this.atributo.descripcion.length <= 0) {
          this.errores['descripcion'] = <string>this.translator.instant('VALOR_REQUERIDO');
          esValido = false;
      }

      if (this.atributo.descripcion !== null && this.atributo.descripcion.length > 80) {
          this.errores['descripcion'] = <string>this.translator.instant('MAX_LONGITUD', { max: 80 });
          esValido = false;
      }

    // if the value is a list then, there is no need for hand set default value
    //   if (this.atributo.valorDefault !== null && this.atributo.valorDefault.length > 80 ) {
    //       this.errores['valorDefault'] = <string>this.translator.instant('MAX_LONGITUD', { max: 80 });
    //       esValido = false;
    //   }

    return esValido;
  }

  private resetearErrores() {
      Object.keys(this.errores).forEach(key => this.errores[key] = null);
  }

  volverAlListado() {
    this.router.navigate(['../'], { relativeTo: this.aRoute });
  }

  seleccionarOpcion(opcion) {
    this.atributo.tipoDato = opcion;
    if(this.atributo.tipoDato === 'LIST'){
        this.isList = true;
        this.atributo.opcional = false;
        this.jdefaults={};
    }else{
        this.isList = false;
        this.jdefaults={};
    }

  }

  selectEditAtributeList(){
      this.router.navigate(['.', this.atributo.formList.idFormulario], { relativeTo: this.aRoute });
  }

}




// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/atributos/detalle.atributos.component.ts